//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ValidationObserver } from 'vee-validate'

export default {
  name: 'CardRegisterLogin',
  components: { ValidationObserver },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    step: {
      type: String,
      default: '1/1',
    },
    buttonAction: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {}
  },
}
